import React, { useEffect } from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Footer from "../../../views/website/footer";
import { Box } from "@mui/material";
import EventsAppBar from "./EventsAppBar";


export function EventsLayout(props)
{
    useEffect(()=>{
        window.scrollTo(0,0);
    })



    return(
        <div>
            <EventsAppBar/>
            <Box sx={{paddingTop:6,minHeight:'100vh'}}>
                {props.children}
            </Box>
            <Footer/>
        </div>
    )
}